/* tslint:disable */
/* eslint-disable */
/* @relayHash 71acafe7a8613d194937b65faa4d8423 */

import { ConcreteRequest } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type App_Holder_QueryVariables = {};
export type App_Holder_QueryResponse = {
    readonly manager: {
        readonly " $fragmentRefs": FragmentRefs<"AppHolder_manager">;
    } | null;
};
export type App_Holder_Query = {
    readonly response: App_Holder_QueryResponse;
    readonly variables: App_Holder_QueryVariables;
};



/*
query App_Holder_Query {
  manager {
    ...AppHolder_manager
  }
}

fragment AppHolder_manager on Manager {
  uuid
  firstName
  lastName
  profileImageUrl
  hasComplianceAccess
  company {
    logoURL
    name
    securityProgrammes(page: {offset: 0, limit: 0}) {
      pageInfo {
        total
      }
    }
    machineReports(page: {offset: 0, limit: 0}, filter: {sent: true}) {
      pageInfo {
        total
      }
    }
  }
  ...ManagerSlideIn_manager
  ...HeaderMenu_manager
}

fragment HeaderMenu_manager on Manager {
  company {
    name
  }
}

fragment ManagerSlideIn_manager on Manager {
  uuid
  firstName
  lastName
  email
  jobTitle
  telephone
  profileImageUrl
  company {
    logoURL
    uuid
    name
    contactEmail
    address {
      addressLine1
      addressLine2
      county
      postCode
    }
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "uuid",
        "args": null,
        "storageKey": null
    } as any), v1 = ({
        "kind": "Literal",
        "name": "page",
        "value": {
            "limit": 0,
            "offset": 0
        }
    } as any), v2 = [
        ({
            "kind": "LinkedField",
            "alias": null,
            "name": "pageInfo",
            "storageKey": null,
            "args": null,
            "concreteType": "PageInfo",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "total",
                    "args": null,
                    "storageKey": null
                }
            ]
        } as any)
    ];
    return {
        "kind": "Request",
        "fragment": {
            "kind": "Fragment",
            "name": "App_Holder_Query",
            "type": "Query",
            "metadata": null,
            "argumentDefinitions": [],
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "manager",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Manager",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "FragmentSpread",
                            "name": "AppHolder_manager",
                            "args": null
                        }
                    ]
                }
            ]
        },
        "operation": {
            "kind": "Operation",
            "name": "App_Holder_Query",
            "argumentDefinitions": [],
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "manager",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Manager",
                    "plural": false,
                    "selections": [
                        (v0 /*: any*/),
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "firstName",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "lastName",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "profileImageUrl",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "hasComplianceAccess",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "company",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Company",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "logoURL",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "name",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "securityProgrammes",
                                    "storageKey": "securityProgrammes(page:{\"limit\":0,\"offset\":0})",
                                    "args": [
                                        (v1 /*: any*/)
                                    ],
                                    "concreteType": "SecurityProgrammePage",
                                    "plural": false,
                                    "selections": (v2 /*: any*/)
                                },
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "machineReports",
                                    "storageKey": "machineReports(filter:{\"sent\":true},page:{\"limit\":0,\"offset\":0})",
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "filter",
                                            "value": {
                                                "sent": true
                                            }
                                        },
                                        (v1 /*: any*/)
                                    ],
                                    "concreteType": "MachineReportPage",
                                    "plural": false,
                                    "selections": (v2 /*: any*/)
                                },
                                (v0 /*: any*/),
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "contactEmail",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "address",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "Address",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "addressLine1",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "addressLine2",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "county",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "postCode",
                                            "args": null,
                                            "storageKey": null
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "email",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "jobTitle",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "telephone",
                            "args": null,
                            "storageKey": null
                        }
                    ]
                }
            ]
        },
        "params": {
            "operationKind": "query",
            "name": "App_Holder_Query",
            "id": null,
            "text": "query App_Holder_Query {\n  manager {\n    ...AppHolder_manager\n  }\n}\n\nfragment AppHolder_manager on Manager {\n  uuid\n  firstName\n  lastName\n  profileImageUrl\n  hasComplianceAccess\n  company {\n    logoURL\n    name\n    securityProgrammes(page: {offset: 0, limit: 0}) {\n      pageInfo {\n        total\n      }\n    }\n    machineReports(page: {offset: 0, limit: 0}, filter: {sent: true}) {\n      pageInfo {\n        total\n      }\n    }\n  }\n  ...ManagerSlideIn_manager\n  ...HeaderMenu_manager\n}\n\nfragment HeaderMenu_manager on Manager {\n  company {\n    name\n  }\n}\n\nfragment ManagerSlideIn_manager on Manager {\n  uuid\n  firstName\n  lastName\n  email\n  jobTitle\n  telephone\n  profileImageUrl\n  company {\n    logoURL\n    uuid\n    name\n    contactEmail\n    address {\n      addressLine1\n      addressLine2\n      county\n      postCode\n    }\n  }\n}\n",
            "metadata": {}
        }
    } as any;
})();
(node as any).hash = 'ae1f32a58cdf66e3f2f3dc9abd5b102d';
export default node;
